// extracted by mini-css-extract-plugin
module.exports = {"actions":"ProductStockForm_actions__3iRut"};